import { TypedDocumentNode } from '@graphql-typed-document-node/core'

import {
  FormattedAssignment,
  FormattedAssignmentWithDeletion,
} from 'modules/cost_centers/components/CostCenterAssigments/lib/types'
import { useCostCentersMutations } from 'modules/cost_centers/hooks/useCostCentersMutations'

import { SaveButton } from './SaveButton'

interface Props {
  assignmentsToCreate: FormattedAssignment[]
  assignmentsToUpdate: FormattedAssignmentWithDeletion[]
  disabled: boolean
  resourceId: string
  resourceType: string
  onSave?: () => void
  refetchQueries?: TypedDocumentNode[]
}

export const UpdateButton = ({
  assignmentsToCreate,
  assignmentsToUpdate,
  disabled,
  resourceId,
  resourceType,
  refetchQueries,
  onSave,
}: Props) => {
  const { save } = useCostCentersMutations(refetchQueries)

  const handleOnClick = async () => {
    const resolveEndDate = (assignment: FormattedAssignment) => {
      // Preserve the actual endDate value regardless of isDefault.
      // Default assignments can have endDates set by the backend (e.g. when
      // a future assignment group was created), and we must always send them.
      // Only normalize empty/missing values to null.
      return assignment.endDate || null
    }

    const successSave = await save({
      assignmentsToCreate: assignmentsToCreate.map((assignment) => {
        return {
          costCenterId: assignment.costCenterId ?? '',
          percentage: assignment.percentage,
          startDate: assignment.startDate,
          endDate: resolveEndDate(assignment),
          resourceId: resourceId,
          resourceType: resourceType,
        }
      }),
      assignmentsToUpdate: assignmentsToUpdate.map((assignment) => {
        return {
          costCenterId: assignment.costCenterId ?? '',
          percentage: assignment.percentage,
          startDate: assignment.startDate,
          endDate: resolveEndDate(assignment),
          id: assignment.id,
          markedForDeletion: !!assignment.markedForDeletion,
        }
      }),
    })

    if (successSave) {
      onSave?.()
    }
  }

  return <SaveButton disabled={disabled} onSave={handleOnClick} />
}
